module.exports = __webpack_public_path__ + "media/belt-driven-tragedy.92c09a20.mp3";